// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextInput_input__RNP63 {
  width: 100%;
  height: 34px;
  border: 1px solid lightgray;
  border-radius: 4px;
  padding: 0.5rem;
}
.TextInput_input__RNP63:focus {
  border: 1px solid #333333;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/TextInput.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,yBAAA;EACA,aAAA;AACJ","sourcesContent":[".input {\n  width: 100%;\n  height: 34px;\n  border: 1px solid lightgray;\n  border-radius: 4px;\n  padding: 0.5rem;\n}\n.input:focus {\n  border: 1px solid #333333;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `TextInput_input__RNP63`
};
export default ___CSS_LOADER_EXPORT___;
